import request from '@/api/config/request'

const prex = "api/admin/configuracao/paramentro/";

export function GetParamentroGeral() {
    return request({
        url: `${prex}geral`,
        method: 'get',
    })
}

export function setParamentroGeral(data) {
    return request({
        url: `${prex}geral`,
        method: 'post',
        data
    })
}